import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';

import { AuthGuard } from './core/services/auth-guard.service';
import { AppLandingComponent } from './pages/app.landing.component';

import { RegistroComponent } from './registro/registro.component';
import { AppResetpasswordComponent } from './pages/app.resetpassword.component';
import { AppResetpasswordConfigComponent } from './pages/app.resetpasswordconfig.component';
import { AppAdminComponent } from './app.admin.component';

const routes: Routes = [
    { path: '', loadChildren: () => import('./inicio/inicio.module').then((m) => m.InicioModule), pathMatch: 'full' },
    {
        path: 'fazil-console',
        component: AppAdminComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'administracion',
                loadChildren: () => import('./administracion/administracion.module').then((m) => m.AdministracionModule)
            },
        ]
    },
    {
        path: 'fazil',
        component: AppMainComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'facturas',
                loadChildren: () => import('./facturas/facturas.module').then((m) => m.FacturasModule)
            },
            {
                path: 'contactos',
                loadChildren: () => import('./contactos/contactos.module').then((m) => m.ContactosModule)
            },
            {
                path: 'servicios',
                loadChildren: () => import('./servicios/servicios.module').then((m) => m.ServiciosModule)
            },
            {
                path: 'perfil',
                loadChildren: () => import('./perfil/perfil.module').then((m) => m.PerfilModule)
            },
            {
                path: 'auditoria',
                loadChildren: () => import('./auditoria/auditoria.module').then((m) => m.AuditoriaModule)
            },
            {
                path: 'planes',
                component: AppLandingComponent
            },
            {
                path: 'pos',
                loadChildren: () => import('./pos/pos.module').then((m) => m.POSModule)
            },
            {
                path: 'agendamiento',
                loadChildren: () => import('./agendamiento/agendamiento.module').then((m) => m.AgendamientoModule)
            },
        ]
    },
    {
        path: 'embebed',
        component: AppComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'facturas',
                loadChildren: () => import('./facturas/facturas.module').then((m) => m.FacturasModule)
            }
        ]
    },
    {
        path: 'registrar',
        loadChildren: () => import('./registro/registro.module').then((m) => m.RegistroModule) },
    {
        path: 'agenda/:slug',
        loadChildren: () => import('./agenda-publica/agenda-publica.module').then((m) => m.AgendaPublicaModule) },
    { path: 'error', component: AppErrorComponent },
    { path: 'landing', component: AppLandingComponent },
    { path: 'access', component: AppAccessdeniedComponent },
    { path: 'notfound', component: AppNotfoundComponent },
    { path: 'login', component: AppLoginComponent },
    { path: 'login/v2', component: AppResetpasswordComponent },
    { path: 'login/v2/perfil', component: AppResetpasswordConfigComponent },
    { path: '**', redirectTo: '/notfound' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            enableTracing: true,
            relativeLinkResolution: 'legacy'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
